define((require) => {
    "use strict";

    const Window                                            = require("shared/services/Window");
    const {Logger}                                            = require("shared/util/Logger");
    const SalesforceCommerceQuickViewSiteGenesisStrategy    = require("shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewSiteGenesisStrategy");

    const log = new Logger("SalesforceCommerceQuickViewSiteGenesisCustomStrategy");

    /**
     * Exposes a SalesforceCommerce QuickView SiteGenesis Custom Strategy Class.
     * Available from Site Genesis version >= 15.1 and a Zmags Creator cartridge
     * needs to be installed on client side.
     *
     * @class SalesforceCommerceQuickViewSiteGenesisCustomStrategy
     */
    return SalesforceCommerceQuickViewSiteGenesisStrategy.extend({

        /**
         * Opens custom Zmags SalesforceCommerce QuickView function
         * @param {String} productID - The product Id.
         * @param {String} experienceName The experience name.
         * @param {Number} currentScene The current scene number.
         * @param {Function} [onClose] Function to be called on quickview close, if possible.
         * @return {Boolean} True if <tt>onClose</tt> was specified and successfully hooked into the QuickView close
         *                   cycle, false otherwise.
         */
        open(productID, experienceName, currentScene) {
            const win = Window.topWindow();
            const url = Window.sandbox("Urls.getProductUrl", win);
            const productURL = url + this.formatParameters(productID, experienceName, currentScene);

            Window.run({code: `__zmags.demandware.quickview.show({source:"quickview", url:"${productURL}"})`, win});

            log.info(`Custom SalesforceCommerce QuickView launched for product: ${productID} for the Experience ${experienceName} on page: ${win.location.href}`);
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewSiteGenesisCustomStrategy.js